/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */

// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { Box, TableCell, TableRow } from "@mui/material";
import React, { useContext, useState } from "react";
import * as Sentry from "@sentry/react";

import { Moving } from "@mui/icons-material";
import tableStyle from "../../../theme/styles/table";
// import DeleteIcon from "../../../../assets/svg/Delete";

import { style } from "./style";
import Button from "../../../components/common/Button";
import { APPOINTMENT_TRACKING_COL } from "../../../contants/table/appointment";
import Table from "../../../components/common/new/Table/Table";
import useUserConfig from "../../../hooks/useUserConfig";
import { AlertStatus, PERMISSIONS } from "../../../contants";
import Appointment from "../../../services/api/appointment";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Alert from "../../../components/common/new/Alert/Alert";
import AppointmentCancelRequestModal from "../../../components/AppointmentModals/AppointmentCancelRequestModal/AppointmentCancelRequestModal";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const getRows = ({
  searchData,
  onMemberSelect,
  onResendLink,
  onCancelRequestApplication,
  onpush,
}) => {
  const hasPermission = useUserConfig();

  return searchData?.map((member) => {
    const showIcon =
      (member?.structureLevel === "REGION" &&
        member?.status === "AAC_FIRST_APPROVED") ||
      (member?.structureLevel === "ZONE" && member?.status === "RECOMMENDED");
    const resendLink = member?.allowedToResendConsent;
    return (
      <TableRow style={tableStyle.tableRow}>
        <TableCell
          style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}
        >
          {member.memberDetails.memberId}
        </TableCell>
        <TableCell style={style.Cell}>
          {member.memberDetails.fullName || "-"}
          <br />
          {member.memberDetails.addressLine1 || "-"}
        </TableCell>
        <TableCell style={style.Cell}>
          {member.memberDetails.mobileNumber || "-"}
          <br />
          {member.memberDetails.emailId || "-"}
        </TableCell>
        <TableCell style={style.Cell}>
          {member.memberDetails.divisionName || "-"}
        </TableCell>
        <TableCell style={{ ...style.Cell, ...tabelCellWidth.medium }}>
          {member.structureLevel === "BLOCK"
            ? [
                member?.memberDetails?.areaName,
                member?.memberDetails?.clusterName,
                member?.memberDetails?.zoneName,
                member?.memberDetails?.regionName,
                member?.memberDetails?.chapterName,
                member?.memberDetails?.districtName,
                member?.memberDetails?.blockName,
              ]
                .filter(Boolean)
                .join("/ ")
            : member.structureLevel === "DISTRICT"
            ? [
                member?.memberDetails?.areaName,
                member?.memberDetails?.clusterName,
                member?.memberDetails?.zoneName,
                member?.memberDetails?.regionName,
                member?.memberDetails?.chapterName,
                member?.memberDetails?.districtName,
              ]
                .filter(Boolean)
                .join("/ ")
            : member.structureLevel === "CHAPTER"
            ? [
                member?.memberDetails?.areaName,
                member?.memberDetails?.clusterName,
                member?.memberDetails?.zoneName,
                member?.memberDetails?.regionName,
                member?.memberDetails?.chapterName,
              ]
                .filter(Boolean)
                .join("/ ")
            : member.structureLevel === "REGION"
            ? [
                member?.memberDetails?.areaName,
                member?.memberDetails?.clusterName,
                member?.memberDetails?.zoneName,
                member?.memberDetails?.regionName,
              ]
                .filter(Boolean)
                .join("/ ")
            : member.structureLevel === "ZONE"
            ? [
                member?.memberDetails?.areaName,
                member?.memberDetails?.clusterName,
                member?.memberDetails?.zoneName,
              ]
                .filter(Boolean)
                .join("/ ")
            : member.structureLevel === "CLUSTER"
            ? [
                member?.memberDetails?.areaName,
                member?.memberDetails?.clusterName,
              ]
                .filter(Boolean)
                .join("/ ")
            : [member?.memberDetails?.areaName]}
        </TableCell>
        <TableCell style={style.Cell}>
          {member.appliedForName || "NA"}
        </TableCell>
        <TableCell style={style.Cell}>
          <Box style={style.status}>{member.statusValue}</Box>
        </TableCell>
        <TableCell style={{ color: "#8C8C8C" }}>
          <Box style={{ ...style.flexC, textAlign: "center" }}>
            <Box style={{ ...style.ActionBtnContainer }}>
              <Button
                onClick={() =>
                  onMemberSelect(member.memberDetails.memberId, "tracking")
                }
                style={{
                  ...style.actionBtn,
                  marginBottom: "10px",
                  height: "30px",
                }}
                label="REVIEW"
                variant="outlined"
              />
              {member.status !== "CANCELLED" &&
                hasPermission(PERMISSIONS.CANCEL_APPOINTMENT_APPLICATION) && (
                  <Button
                    onClick={() => onCancelRequestApplication(member)}
                    variant="outlined"
                    style={{
                      ...style.actionBtn,
                      marginBottom: "10px",
                    }}
                    label="CANCEL"
                  />
                )}
            </Box>
          </Box>
          {member.status === "INTERVIEWED" && resendLink === true && (
            // hasPermission(PERMISSIONS.RESEND_CONSENT_LINK) &&
            <Box style={{ ...style.flexC, marginTop: "8px" }}>
              <Box style={{ ...style.ActionBtnContainer }}>
                <Button
                  onClick={() => onResendLink(member)}
                  style={{
                    ...style.actionBtn,
                    height: "30px",
                    minWidth: "115px",
                    backgroundColor: " 	#C1E1C1",
                    border: " 1px solid	#228B22",
                    fontSize: "10px",
                    color: "#228B22",
                  }}
                  label="RESEND LINK"
                  variant="outlined"
                />
              </Box>
            </Box>
          )}
          {hasPermission(PERMISSIONS.ADMIN_FORCE_PUSH) && showIcon && (
            <Box
              style={{
                ...style.flexC,
                marginTop: "8px",
              }}
            >
              <Box
                style={{
                  ...style.ActionBtnContainer,
                  padding: "0px, 4px, 0px 4px",
                }}
              >
                <Moving
                  onClick={() => onpush(member)}
                  style={{
                    cursor: "pointer",
                    height: "24px",
                    border: " 1px solid	#228B22",
                    borderRadius: "4px",
                  }}
                />
              </Box>
            </Box>
          )}
        </TableCell>
      </TableRow>
    );
  });
};

function AppointmentTrackingTable({
  searchData,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onMemberSelect,
  hasPermission,
  showStatusColumn,
  onEdit,
  onToggleHDC,
  isChapterSi,
  isHelpDesk,
  isAreaSi,
  isClusterSi,
  isZoneSi,
  isHelpDeskAdmin,
  refreshList,
}) {
  const columns = APPOINTMENT_TRACKING_COL;
  const toast = useContext(ToastAlertContext);

  const [openAlert, setOpenAlert] = useState(false);
  const [openPushAlert, setOpenPushAlert] = useState(false);

  const [selectedApplication, setSelectedApplication] = useState([]);
  const [openCancelRequestModal, setOpenCancelRequestModal] = useState(false);

  const closeCancelRequestModal = () => {
    setOpenCancelRequestModal(false);
  };

  const onCancelRequestApplication = (application) => {
    setSelectedApplication(application);
    setOpenCancelRequestModal(true);
  };

  const toggleAlert = () => setOpenAlert((prev) => !prev);

  const togglePushAlert = () => setOpenPushAlert((prev) => !prev);

  const onResendLink = (application) => {
    setSelectedApplication(application);
    setOpenAlert(true);
  };

  const onpush = (application) => {
    setSelectedApplication(application);
    setOpenPushAlert(true);
  };

  const onHitResend = async () => {
    try {
      await Appointment.resendConsent(
        selectedApplication?.memberDetails?.memberId,
        selectedApplication?.id
      );
      toast.show("Consent Email sent Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        toggleAlert();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const onForcePush = async () => {
    try {
      await Appointment.AppointmentAdminPush(
        selectedApplication?.memberDetails?.memberId,
        selectedApplication?.id
      );
      toast.show(
        "Appointment is pushed successfully to next step",
        AlertStatus.SUCCESS
      );
      setTimeout(() => {
        togglePushAlert();
        refreshList();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          onSelectMemberForTransfer,
          onMemberSelect,
          hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
          isChapterSi,
          isHelpDesk,
          isAreaSi,
          isClusterSi,
          isZoneSi,
          onEdit,
          onToggleHDC,
          isHelpDeskAdmin,
          onResendLink,
          onCancelRequestApplication,
          onpush,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...style.tableHeadCells,
          textAlign: "center",
        }}
      />

      <Alert open={openAlert} onClose={toggleAlert} onSubmit={onHitResend} />

      {/* Force Push Icon  Alert Modal handling */}
      <Alert
        open={openPushAlert}
        onClose={togglePushAlert}
        onSubmit={onForcePush}
      />

      <AppointmentCancelRequestModal
        open={openCancelRequestModal}
        onClose={closeCancelRequestModal}
        application={selectedApplication}
        refreshList={refreshList}
        toast={toast}
      />
    </div>
  );
}

export default AppointmentTrackingTable;
